<div id="top-notification" class="aep-error-card">
    <div class="message">
        {{ getMessage() }}
    </div>
    <div class="buttons-container">
        <span class="action-button" *ngIf="action" (click)="exAction()">{{ getActionLabel() }}</span>
        <span class="close-button" (click)="closeNotification()">
            <mat-icon svgIcon="mat_outline:close"></mat-icon>
        </span>
    </div>
</div>
